import { Box, Stack, Typography } from '@mui/material';

const HorizontalBarList = ({ data, tone = 'green', formatNumber }) => {
  const maxValue = Math.max(...data.map((item) => item.value), 1);
  const fill =
    tone === 'blue'
      ? 'linear-gradient(90deg, #60a5fa, #0c53b7)'
      : 'linear-gradient(90deg, #6ee7b7, #00a76f)';

  return (
    <Stack spacing={1.75}>
      {data.map((item) => (
        <Stack key={item.label} spacing={0.75}>
          <Stack direction="row" justifyContent="space-between" spacing={2}>
            <Typography variant="body2" sx={{ fontWeight: 600 }}>
              {item.label}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {formatNumber(item.value)}
            </Typography>
          </Stack>
          <Box
            sx={{
              height: 12,
              borderRadius: 999,
              backgroundColor: 'rgba(148, 163, 184, 0.16)',
              overflow: 'hidden'
            }}
          >
            <Box
              sx={{
                width: `${Math.max((item.value / maxValue) * 100, 8)}%`,
                height: '100%',
                borderRadius: 999,
                background: fill
              }}
            />
          </Box>
        </Stack>
      ))}
    </Stack>
  );
};

export default HorizontalBarList;
